import { render, staticRenderFns } from "./KycSignatoryInfo.vue?vue&type=template&id=47efce3c&scoped=true"
import script from "./KycSignatoryInfo.vue?vue&type=script&lang=js"
export * from "./KycSignatoryInfo.vue?vue&type=script&lang=js"
import style0 from "./KycSignatoryInfo.vue?vue&type=style&index=0&id=47efce3c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47efce3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47efce3c')) {
      api.createRecord('47efce3c', component.options)
    } else {
      api.reload('47efce3c', component.options)
    }
    module.hot.accept("./KycSignatoryInfo.vue?vue&type=template&id=47efce3c&scoped=true", function () {
      api.rerender('47efce3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/kyc/KycSignatoryInfo.vue"
export default component.exports